import { Component, h } from '@stencil/core'

@Component({
  tag: 'app-page',
  styleUrl: 'app.scss',
  shadow: true,
  assetsDirs: ['assets'],
})
export class AppPage {
  render() {
    return (
      <div class="search-home-page">
        <img src="../assets/search-party-team-logo.png" alt="Search Party Team Logo" />
        <div class="search-home-page-header">
          <h1 class="c11n-text-2xl-headline c11n-space-stack-4x"> Welcome to Search Party Team Page</h1>
          <h2 class="c11n-space-stack-1x c11n-text-xl"> Here you can find all the docs related to our component and how it works for other teams</h2>
          <search-widget></search-widget>
        </div>
        <div class="search-home-page-tab">
          <tradelab-search-widget filterSearchParams="types=otherFunds" />
        </div>
      </div>
    )
  }
}
